import { render } from "./Tree.vue?vue&type=template&id=20c4c514"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
script.render = render

export default script